import { combineReducers } from "redux";
import { firebaseReducer } from "react-redux-firebase";
import { firestoreReducer } from "redux-firestore";

import authReducer from "./authReducer";
import dictionaryReducer from "./dictionaryReducer";
import testsReducer from "./testsReducer";
import storeReducer from "./storeReducer";

export default combineReducers({
  auth: authReducer,
  dictionary: dictionaryReducer,
  tests: testsReducer,
  store: storeReducer,
  firebase: firebaseReducer,
  firestore: firestoreReducer,
});
